// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"662": "__federation_expose_Simulation","663": "__federation_expose_Lesion",}[chunkId] || chunkId) + "." + {"396": "6966c5a7","486": "79955a4d","662": "a145c64f","663": "a341edf2","75": "8b155fb8","863": "61547467",}[chunkId] + ".js"
}